export default __webpack_public_path__ + "static/media/icon-home-3.5d6b8a3e.png";